import { axios } from "../../helper/axios";
import { CustomerTableConstant } from "./customerTableConstant";

const customerTableApi = {};

customerTableApi.getCustomerTable = ({
  vendor_id,
  model_id,
  station_id,
  manufacturer_id,
}) => {
  if (vendor_id === "All") {
    vendor_id = "";
  }
  if (model_id === "All") {
    model_id = "";
  }
  if (station_id === "All") {
    station_id = "";
  }
  if (manufacturer_id === "All") {
    manufacturer_id = "";
  }
  let qeuryParam = `?vendor_id=${vendor_id}&model_id=${model_id}&station_id=${station_id}&manufacturer_id=${manufacturer_id}`;

  return axios.get(`${CustomerTableConstant.CUSTOMER_TABLE_API}${qeuryParam}`);
};

export { customerTableApi };
